var map = {
	"./annotation.svg": 88830,
	"./arrowLeft.svg": 55091,
	"./avatar.svg": 97565,
	"./burger.svg": 88757,
	"./calendar.svg": 22513,
	"./celebrationIcon.svg": 55215,
	"./checkCircle.svg": 92277,
	"./chevronDown.svg": 91456,
	"./clipboardCopy.svg": 24610,
	"./collection.svg": 90945,
	"./collection1.svg": 93449,
	"./cross.svg": 600,
	"./documentDuplicate.svg": 26351,
	"./dotsHorizontal.svg": 75841,
	"./elipsesHorizontal.svg": 91764,
	"./exclamationCircle.svg": 84867,
	"./eye.svg": 88203,
	"./folder.svg": 25858,
	"./menu.svg": 58615,
	"./messageSquare.svg": 34644,
	"./moon.svg": 93714,
	"./officeBuilding.svg": 28043,
	"./pencil.svg": 23756,
	"./pencilAlt.svg": 59848,
	"./plus1.svg": 15046,
	"./plus2.svg": 61129,
	"./plusIcon.svg": 18300,
	"./search.svg": 98783,
	"./sortAscending.svg": 96279,
	"./sun.svg": 10709,
	"./tag.svg": 38108,
	"./userGroup.svg": 87091,
	"theme/images/annotation.svg": 88830,
	"theme/images/arrowLeft.svg": 55091,
	"theme/images/avatar.svg": 97565,
	"theme/images/burger.svg": 88757,
	"theme/images/calendar.svg": 22513,
	"theme/images/celebrationIcon.svg": 55215,
	"theme/images/checkCircle.svg": 92277,
	"theme/images/chevronDown.svg": 91456,
	"theme/images/clipboardCopy.svg": 24610,
	"theme/images/collection.svg": 90945,
	"theme/images/collection1.svg": 93449,
	"theme/images/cross.svg": 600,
	"theme/images/documentDuplicate.svg": 26351,
	"theme/images/dotsHorizontal.svg": 75841,
	"theme/images/elipsesHorizontal.svg": 91764,
	"theme/images/exclamationCircle.svg": 84867,
	"theme/images/eye.svg": 88203,
	"theme/images/folder.svg": 25858,
	"theme/images/menu.svg": 58615,
	"theme/images/messageSquare.svg": 34644,
	"theme/images/moon.svg": 93714,
	"theme/images/officeBuilding.svg": 28043,
	"theme/images/pencil.svg": 23756,
	"theme/images/pencilAlt.svg": 59848,
	"theme/images/plus1.svg": 15046,
	"theme/images/plus2.svg": 61129,
	"theme/images/plusIcon.svg": 18300,
	"theme/images/search.svg": 98783,
	"theme/images/sortAscending.svg": 96279,
	"theme/images/sun.svg": 10709,
	"theme/images/tag.svg": 38108,
	"theme/images/userGroup.svg": 87091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33640;